import React from "react";
import { errorBoundaryFallback } from "../../../locales/en";
function ListViewFallback() {
  const handleReload = (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    window.location.reload();
  };

  return (
    <div className="text-center mt-50">
      <h4>{errorBoundaryFallback.common.listFallback.text1}</h4>

      <a href="#" onClick={handleReload}>
        <strong>{errorBoundaryFallback.common.listFallback.reloadLink}</strong>
      </a>

      <span>{` ${errorBoundaryFallback.common.listFallback.text2} `}</span>
    </div>
  );
}

export default ListViewFallback;
